import { CommonModule } from '@angular/common';
import { UiHeaderFooterBundle, UiFooterComponent } from '../shared';
import { Panel as PanelBase } from 'prime-ng-old/panel';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UiIconsModule } from '../icons';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icons/icon.component";
const _c0 = ["*", [["ui-header"]], [["ui-footer"]]];
const _c1 = ["*", "ui-header", "ui-footer"];
const _c2 = (a0, a1, a2, a3) => ({
  "p-panel p-component": true,
  "p-panel-toggleable": a0,
  "p-panel-expanded": a1,
  "has-footer": a2,
  "emphasized": a3
});
const _c3 = a0 => ({
  transitionParams: a0,
  height: "0",
  opacity: "0"
});
const _c4 = a0 => ({
  value: "hidden",
  params: a0
});
const _c5 = a0 => ({
  transitionParams: a0,
  height: "*",
  opacity: "1"
});
const _c6 = a0 => ({
  value: "visible",
  params: a0
});
const _c7 = (a0, a1, a2) => ({
  "p-panel-icons-start": a0,
  "p-panel-icons-end": a1,
  "p-panel-icons-center": a2
});
function UiPanelComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r1.id + "_header");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
function UiPanelComponent_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPanelComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "ui-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.collapsed ? "chevron-right" : "chevron-down");
  }
}
function UiPanelComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function UiPanelComponent_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onHeaderClick($event));
    });
    i0.ɵɵconditionalCreate(1, UiPanelComponent_Conditional_1_Conditional_1_Template, 2, 2, "span", 7);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵtemplate(3, UiPanelComponent_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵconditionalCreate(5, UiPanelComponent_Conditional_1_Conditional_5_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.id + "-titlebar");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.header ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c7, ctx_r1.iconPos === "start", ctx_r1.iconPos === "end", ctx_r1.iconPos === "center"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.toggleable ? 5 : -1);
  }
}
function UiPanelComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPanelComponent_Conditional_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPanelComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵtemplate(2, UiPanelComponent_Conditional_6_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
export let UiPanelComponent = /*#__PURE__*/(() => {
  class UiPanelComponent extends PanelBase {
    constructor() {
      super(...arguments);
      this.showHeader = true;
      this.flexContent = true;
      this.fillHeight = false;
      this.padding = true;
      this.emphasized = false;
      this.toggler = 'header';
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiPanelComponent_BaseFactory;
        return function UiPanelComponent_Factory(__ngFactoryType__) {
          return (ɵUiPanelComponent_BaseFactory || (ɵUiPanelComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiPanelComponent)))(__ngFactoryType__ || UiPanelComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiPanelComponent,
        selectors: [["ui-panel"]],
        contentQueries: function UiPanelComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiFooterComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerFacet = _t.first);
          }
        },
        hostAttrs: [1, "p-element"],
        hostVars: 6,
        hostBindings: function UiPanelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("flex-content", ctx.flexContent)("fill-height", ctx.fillHeight)("padded", ctx.padding);
          }
        },
        inputs: {
          showHeader: "showHeader",
          flexContent: "flexContent",
          fillHeight: "fillHeight",
          padding: "padding",
          emphasized: "emphasized"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1,
        decls: 7,
        vars: 27,
        consts: [[3, "ngClass", "ngStyle"], [1, "p-panel-header"], ["role", "region", 1, "p-toggleable-content", "p-panel-content-wrapper", 3, "id"], [1, "p-panel-content"], [4, "ngTemplateOutlet"], [1, "p-panel-footer"], [1, "p-panel-header", 3, "click"], [1, "p-panel-title"], [1, "p-panel-icons", 3, "ngClass"], ["role", "tablist", 1, "p-panel-header-icon"], [3, "icon"]],
        template: function UiPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵconditionalCreate(1, UiPanelComponent_Conditional_1_Template, 6, 9, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵlistener("@panelContent.done", function UiPanelComponent_Template_div_animation_panelContent_done_2_listener($event) {
              return ctx.onToggleDone($event);
            });
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵtemplate(5, UiPanelComponent_ng_container_5_Template, 1, 0, "ng-container", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(6, UiPanelComponent_Conditional_6_Template, 3, 1, "div", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(14, _c2, ctx.toggleable, !ctx.collapsed && ctx.toggleable, ctx.footerFacet, ctx.emphasized))("ngStyle", ctx.style);
            i0.ɵɵattribute("id", ctx.id)("data-pc-name", "panel");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showHeader ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id + "_content")("@panelContent", ctx.collapsed ? i0.ɵɵpureFunction1(21, _c4, i0.ɵɵpureFunction1(19, _c3, ctx.animating ? ctx.transitionOptions : "0ms")) : i0.ɵɵpureFunction1(25, _c6, i0.ɵɵpureFunction1(23, _c5, ctx.animating ? ctx.transitionOptions : "0ms")));
            i0.ɵɵattribute("aria-labelledby", ctx.id + "_header")("aria-hidden", ctx.collapsed)("tabindex", ctx.collapsed ? "-1" : undefined);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.footerFacet || ctx.footerTemplate ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, UiIconsModule, i2.UiIconComponent],
        styles: ["@layer primeng{.p-panel-header[_ngcontent-%COMP%]{display:flex;align-items:center}.p-panel-title[_ngcontent-%COMP%]{line-height:1;order:1}.p-panel-header-icon[_ngcontent-%COMP%]{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-panel-toggleable.p-panel-expanded[_ngcontent-%COMP%] > .p-toggleable-content[_ngcontent-%COMP%]:not(.ng-animating){overflow:visible}.p-panel-toggleable[_ngcontent-%COMP%]   .p-toggleable-content[_ngcontent-%COMP%]{overflow:hidden}}[_nghost-%COMP%]{display:block}[_nghost-%COMP%]    +ui-panel{margin-top:15px}@media (min-width: 960px){.fill-height[_nghost-%COMP%]{height:100%}.fill-height[_nghost-%COMP%] > .p-panel[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.fill-height[_nghost-%COMP%] > .p-panel[_ngcontent-%COMP%] > .p-panel-content-wrapper[_ngcontent-%COMP%]{flex:1;position:relative}.fill-height[_nghost-%COMP%] > .p-panel[_ngcontent-%COMP%] > .p-panel-content-wrapper[_ngcontent-%COMP%] > .p-panel-content[_ngcontent-%COMP%]{position:absolute;inset:0;overflow:auto}.fill-height[_nghost-%COMP%] > .p-panel.has-footer[_ngcontent-%COMP%] > .p-panel-content-wrapper[_ngcontent-%COMP%] > .p-panel-content[_ngcontent-%COMP%]{bottom:63px}.fill-height[_nghost-%COMP%] > .p-panel.has-footer[_ngcontent-%COMP%] > .p-panel-content-wrapper[_ngcontent-%COMP%] > .p-panel-footer[_ngcontent-%COMP%]{position:absolute;left:0;right:0;bottom:0;height:63px;box-sizing:border-box}}@media (min-width: 960px){.flex-content[_nghost-%COMP%] > .p-panel[_ngcontent-%COMP%] > .p-panel-content-wrapper[_ngcontent-%COMP%] > .p-panel-content[_ngcontent-%COMP%]{display:flex;flex-direction:column}}.p-panel[_ngcontent-%COMP%]{border-radius:4px;background:var(--panelContentBgColor);padding:0;box-sizing:border-box;border:none}.p-panel[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]{padding:0;background-color:var(--panelHeaderBgColor);color:var(--panelHeaderTextColor);border-top-left-radius:4px;border-top-right-radius:4px;display:flex}.p-panel[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]   .p-panel-title[_ngcontent-%COMP%]{order:unset;vertical-align:middle;font-weight:400;font-size:1.2rem}.p-panel[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]   .p-panel-header-icon[_ngcontent-%COMP%]{position:relative;font-size:1em;color:var(--panelHeaderIconColor);border:1px solid transparent;transition:color .3s;margin:0 10px}.p-panel[_ngcontent-%COMP%]   .p-panel-content[_ngcontent-%COMP%]{padding:0;background-color:var(--panelContentBgColor);color:var(--panelContentTextColor)}.p-panel[_ngcontent-%COMP%]   .p-panel-footer[_ngcontent-%COMP%]{padding:0;background-color:var(--panelFooterBgColor);color:var(--panelFooterTextColor);margin:0;height:63px;box-sizing:border-box!important;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.p-panel[_ngcontent-%COMP%]   .p-panel[_ngcontent-%COMP%], .p-panel.emphasized[_ngcontent-%COMP%]{--panelContentBgColor:var(--panelNestedContentBgColor) }.p-panel.p-panel-toggleable[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]:hover{cursor:pointer;background-color:var(--panelHeaderHoverBgColor);color:var(--panelHeaderHoverTextColor)}.p-panel.p-panel-toggleable[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]:hover   .p-panel-header-icon[_ngcontent-%COMP%]{color:var(--panelHeaderIconHoverColor)}.padded[_nghost-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]{padding:8px 10px;border:0;border-width:1px 0 0 0;border-color:var(--panelHeaderBorderColor)}.padded[_nghost-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-content[_ngcontent-%COMP%]{padding:.571em 1em;border:1px solid #c8c8c8;border-color:var(--panelContentBorderColor);border:0;border-width:1px 0 0 0;border-color:var(--panelFooterBorderColor)}.padded[_nghost-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-footer[_ngcontent-%COMP%]{padding:8px 10px}@media (min-width: 768px){.padded[_nghost-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-content[_ngcontent-%COMP%]{padding:1.2em}}@media (min-width: 1600px){.padded[_nghost-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-content[_ngcontent-%COMP%]{padding:1.75em}}"],
        data: {
          animation: [trigger('panelContent', [state('hidden', style({
            height: '0'
          })), state('void', style({
            height: '{{height}}'
          }), {
            params: {
              height: '0'
            }
          }), state('visible', style({
            height: '*'
          })), transition('visible <=> hidden', [animate('{{transitionParams}}')]), transition('void => hidden', animate('{{transitionParams}}')), transition('void => visible', animate('{{transitionParams}}'))])]
        },
        changeDetection: 0
      });
    }
  }
  return UiPanelComponent;
})();
export const UiPanelBundle = [UiPanelComponent, ...UiHeaderFooterBundle];